import axios from 'axios';

const SESSION_KEYS = ['token', 'role', 'username', 'userId'];

export function getToken() {
  return localStorage.getItem('token');
}

export function getSession() {
  return {
    token: localStorage.getItem('token'),
    role: localStorage.getItem('role'),
    username: localStorage.getItem('username'),
    userId: localStorage.getItem('userId')
  };
}

export function setSession({ token, role, username, userId }) {
  if (token) localStorage.setItem('token', token);
  if (role) localStorage.setItem('role', role);
  if (username) localStorage.setItem('username', username);
  if (userId != null) localStorage.setItem('userId', String(userId));
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
}

export function clearSession() {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  if (axios.defaults?.headers?.common) {
    delete axios.defaults.headers.common.Authorization;
  }
}

/**
 * Full logout: revoke token on server, clear local session, force login page.
 * Uses location.replace so browser Back cannot reopen the previous session page.
 */
export async function logout() {
  const token = getToken();

  if (token) {
    try {
      await axios.post(
        '/api/auth/logout',
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
          validateStatus: () => true
        }
      );
    } catch {
      // Still clear local session even if network fails
    }
  }

  clearSession();
  window.location.replace('/login');
}

/**
 * Validate token with server. Returns user or null.
 */
export async function validateSession() {
  const token = getToken();
  if (!token) return null;
  try {
    const res = await axios.get('/api/auth/me', {
      headers: {
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-store'
      }
    });
    return res.data;
  } catch {
    clearSession();
    return null;
  }
}
